import { useState, useCallback } from 'react';

import { checkNumber } from 'utils';

const useValidatedNumber = () => {
  const [state, setState] = useState('');

  const handleChange = useCallback(value => {
    checkNumber(Number(value)) && setState(value.toString().trim());
  }, []);

  return [state, handleChange];
};

export default useValidatedNumber;
